var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "EmdPanel",
        [
          _c(
            "EmdPanelSection",
            { attrs: { title: _vm.$t("recipients.create.recipient") } },
            [
              _vm.isCpf || _vm.isLegacy
                ? _c("name-input", {
                    attrs: {
                      recipient: _vm.recipient,
                      disabled: _vm.disabled,
                      nameInputIsInvalid: _vm.nameInputIsInvalid,
                      vuelidate: _vm.vuelidate,
                    },
                    on: {
                      "update:nameInputIsInvalid": function ($event) {
                        _vm.nameInputIsInvalid = $event
                      },
                      "update:name-input-is-invalid": function ($event) {
                        _vm.nameInputIsInvalid = $event
                      },
                    },
                  })
                : _vm._e(),
              _c("email-input", {
                attrs: { recipient: _vm.recipient, disabled: _vm.disabled },
              }),
              _c("description-input", {
                attrs: {
                  recipient: _vm.recipient,
                  disabled: _vm.disabled || !!_vm.locks.description,
                },
              }),
              _c("document-input", {
                attrs: { recipient: _vm.recipient, disabled: _vm.disabled },
              }),
              !_vm.isLegacy
                ? [
                    _c("site-url-input", {
                      attrs: {
                        recipient: _vm.recipient,
                        disabled: _vm.disabled,
                      },
                    }),
                    !_vm.isCpf
                      ? _c("trading-name-input", {
                          attrs: {
                            recipient: _vm.recipient,
                            disabled: _vm.disabled || !!_vm.locks.trading_name,
                          },
                        })
                      : _vm._e(),
                    !_vm.isCpf
                      ? _c("company-name-input", {
                          attrs: {
                            recipient: _vm.recipient,
                            disabled: _vm.disabled,
                          },
                        })
                      : _vm._e(),
                    !_vm.isCpf
                      ? _c("annual-revenue-input", {
                          attrs: {
                            recipient: _vm.recipient,
                            disabled:
                              _vm.disabled || !!_vm.locks.annual_revenue,
                          },
                        })
                      : _vm._e(),
                    !_vm.isCpf
                      ? _c("founding-date-input", {
                          attrs: {
                            recipient: _vm.recipient,
                            disabled: _vm.disabled || !!_vm.locks.founding_date,
                          },
                        })
                      : _vm._e(),
                    _vm.isCpf
                      ? _c("birthdate-input", {
                          attrs: {
                            recipient: _vm.recipient,
                            disabled: _vm.disabled || !!_vm.locks.birth_date,
                          },
                        })
                      : _vm._e(),
                    _vm.isCpf
                      ? _c("ProfessionalOccupationInput", {
                          attrs: {
                            recipient: _vm.recipient,
                            disabled:
                              _vm.disabled ||
                              !!_vm.locks.professional_occupation,
                          },
                        })
                      : _vm._e(),
                    _vm.isCpf
                      ? _c("MotherNameInput", {
                          attrs: {
                            recipient: _vm.recipient,
                            disabled: _vm.disabled || !!_vm.locks.mother_name,
                          },
                        })
                      : _vm._e(),
                    _vm.isCpf
                      ? _c("MonthlyIncomeInput", {
                          attrs: {
                            recipient: _vm.recipient,
                            disabled:
                              _vm.disabled || !!_vm.locks.monthly_income,
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "phone-container" },
                      [
                        _c("phone-type-input", {
                          staticClass: "phone-type",
                          attrs: {
                            recipient: _vm.recipient,
                            disabled: _vm.disabled,
                          },
                        }),
                        _c("phone-area-number-input", {
                          staticClass: "phone-area",
                          attrs: {
                            recipient: _vm.recipient,
                            disabled: _vm.disabled,
                          },
                        }),
                        _c("phone-number-input", {
                          staticClass: "phone-number",
                          attrs: {
                            recipient: _vm.recipient,
                            disabled: _vm.disabled,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      !_vm.isLegacy && _vm.recipient.address
        ? _c(
            "EmdPanel",
            [
              _c(
                "EmdPanelSection",
                { attrs: { title: _vm.$t("address") } },
                [
                  _c("address-section", {
                    attrs: {
                      canSearchZipCode: _vm.canSearchZipCode,
                      recipient: _vm.recipient,
                      showSideBlock: false,
                    },
                    on: {
                      "update:recipient": function ($event) {
                        _vm.recipient = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }